var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"checkout-modal"},[_c('div',{staticClass:"wrapper"},[_c('img',{attrs:{"src":_setup.hourGlassIcon}}),_c('h2',[_vm._v(_vm._s(_vm.$t('checkout.success.modal.header')))]),_c('h5',[_vm._v(_vm._s(_vm.$t('checkout.success.modal.description')))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }